<template>
    <div class="clnt-content" />
</template>

<script>
export default {
    name: 'Conditions',
};
</script>
